import { call, put, takeLatest } from "redux-saga/effects";
import { GeneralUtilsAction, ManagerAccountReviewAction } from "../../actions";
import * as types from "../../actions/actionTypes";
import * as accountReviewApi from "../../api/accountReview/managerAccountReview";
import { GetFilter } from "../../hocs/accountReviewReport/components/filter/tools/getFilter";
import { SetMessage } from "../../assets/errorMessages";
import { toastr } from "react-redux-toastr";
import * as transactionApi from "../../api/transaction";

export function* managerWatcherAccountReview() {
  yield takeLatest(types.MANAGER_GET_ACCOUNT_REVIEW_REQUEST, worker);
  yield takeLatest(
    types.MANAGER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_REQUEST,
    copyToOtherProject
  );
}

async function fetchList(account_type, pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  return accountReviewApi.getList(page_number, GetFilter());
}

function* worker(action) {
  try {
    const response = yield call(
      fetchList,
      action.account_type,
      action.pageNumber
    );
    yield put(ManagerAccountReviewAction.getSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerAccountReviewAction.getFailure(message));
  }
}

function copyToOtherProjectRequest(data) {
  return transactionApi.managerCopyToAnotherProject(data);
}

function* copyToOtherProject(action) {
  try {
    const response = yield call(copyToOtherProjectRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ManagerAccountReviewAction.copyToAnotherProjectSuccess());
    yield put(GeneralUtilsAction.closeConfirmForTable());
    yield put(GeneralUtilsAction.toggleSelectModeForTable(false));
  } catch (error) {
    SetMessage(error, true);
    yield put(ManagerAccountReviewAction.copyToAnotherProjectFailure());
    yield put(GeneralUtilsAction.closeConfirmForTable());
  }
}
